<footer class="footer">
  <div class="footer-inner">© {{ year }} On Scene Services</div>
</footer>
